import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AuthModule } from '@freelancer/auth';
import { CookieModule } from '@laurentgoudet/ngx-cookie';

import { ErrorTracking } from './error-tracking.service';
import { MemoryLeakTrackingComponent } from './memory-leak-tracking.component';
import { NavigationPerformanceTrackingComponent } from './navigation-performance-tracking.component';
import { PerformanceTracking } from './performance-tracking.service';
import { SyntheticPerformanceTrackingComponent } from './synthetic-performance-tracking.component';
import { TrackingSectionDirective } from './tracking-section.directive';
import { TrackingComponent } from './tracking.component';
import { TRACKING_CONFIG } from './tracking.config';
import { TrackingDirective } from './tracking.directive';
import { TrackingConfig } from './tracking.interface';
import { Tracking } from './tracking.service';
import { UserTimingTrackingComponent } from './user-timing-tracking.component';

@NgModule({
  imports: [HttpClientModule, AuthModule, CookieModule],
  declarations: [
    TrackingComponent,
    TrackingDirective,
    TrackingSectionDirective,
    NavigationPerformanceTrackingComponent,
    UserTimingTrackingComponent,
    MemoryLeakTrackingComponent,
    SyntheticPerformanceTrackingComponent,
  ],
  exports: [TrackingComponent, TrackingDirective, TrackingSectionDirective],
  providers: [ErrorTracking, PerformanceTracking],
  // Exported to GAF
  entryComponents: [TrackingComponent],
})
export class TrackingModule {
  static initialize(config: TrackingConfig): ModuleWithProviders {
    return {
      ngModule: TrackingModule,
      providers: [Tracking, { provide: TRACKING_CONFIG, useValue: config }],
    };
  }
}



// WEBPACK FOOTER //
// ./src/@freelancer/tracking/tracking.module.ts